import { useState, useEffect } from "react";

import request from "project-config/services/request/request";
import { useSetInterval } from "project-config/hooks/useSetInterval";
import { useGlobalStore } from "@/store/GlobalStore";
import { AuthenticateModalContent } from "@renderbus/widgets/components/authenticate-modal";
import { redirectToAuth } from "@/pages/profile/helper/redirectToAuth";
import { AuthStatus } from "project-config/constants";

export function AuthenticateModal() {
  const {
    showAuthenticateModal,
    userInfo,
    setShowAuthenticateModal,
    fetchUserData,
  } = useGlobalStore();
  const [authStatus, setAuthStatus] = useState(AuthStatus.Uncertified);
  const [isQRCodeStart, setQRCodeStart] = useState(false);
  const [token, setToken] = useState("");
  const [authenticateLink, setAuthenticateLink] = useState("");

  const getAuthStatus = async () => {
    const res = await request.post(
      "/api/realpersonauth/user/auth/getUserAuthStatus",
      {}
    );
    return res;
  };
  const getQRCode = async () => {
    const { code, data } = await request.post(
      "/api/realpersonauth/user/generateAuthToken"
    );
    if (code === 200 && data) {
      setToken(data);
      console.log(data);
      setAuthenticateLink(
        `${window.location.protocol}//${
          window.location.host
        }/authenticate/alipay-after-scan?token=${
          data as string
        }&authMethodType=4&origin=''`
      );
    }
  };
  const onRefreshQRCode = async () => {
    setQRCodeStart(false);
    await getQRCode();
    setQRCodeStart(true);
  };
  // 轮询获取认证状态
  useSetInterval(
    async () => {
      const { code, data } = await getAuthStatus();
      if (code === 200 && data) {
        const { authStatus } = data;
        setAuthStatus(authStatus);
        if (authStatus === AuthStatus.Passed) {
          // await queryUser()
          fetchUserData();
        }
        return authStatus === AuthStatus.Passed;
      } else {
        return false;
      }
    },
    5000,
    showAuthenticateModal && !!token
  );
  // 轮询更新二维码
  useSetInterval(
    () => {
      void getQRCode();
    },
    5000,
    showAuthenticateModal && isQRCodeStart
  );

  useEffect(() => {
    if (showAuthenticateModal) {
      const init = async () => {
        const { data: token, code: code1 } = await request.post(
          "/api/rendering/user/generateRealNameAuth"
        );
        if (code1 === 1205) {
          return;
        }
        if (code1 === 200) {
          const res = await request.post("/api/realpersonauth/user/queryUser", {
            rsAuthToken: token,
          });
          if (res.code === 200 && res.data) {
            const { code, data } = await getAuthStatus();
            if (code === 200 && data) {
              setAuthStatus(data.authStatus);
              if (data.authStatus !== AuthStatus.Passed) {
                await onRefreshQRCode();
              }
            }
          }
        }
      };
      void init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAuthenticateModal]);

  return (
    <AuthenticateModalContent
      authStatus={authStatus}
      changeModal={() => {
        setShowAuthenticateModal(false);
        setAuthenticateLink("");
      }}
      showAuthenticateModal={showAuthenticateModal}
      userInfo={userInfo as any}
      authenticateLink={authenticateLink}
      redirectToAuth={() => void redirectToAuth(userInfo).catch(console.trace)}
      redirectToEnterprise={() =>
        void redirectToAuth(
          userInfo,
          false,
          "/authenticate/enterprise-authenticate"
        ).catch(console.trace)
      }
    />
  );
}
